import { useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';

//* Components
import Icon from '@/components/common/Icon';
import Text from '@/components/common/Text';
import CustomLink from '@/components/common/CustomLink';

//* Style
import ShareStyle from './style';

const ShareLink = (props) => {
	//! Router
	const pathname = usePathname();

	//! State
	const [isCopied, setIsCopied] = useState(false);

	//! Copy url function
	const copyUrl = () => {
		const el = document.createElement('input');
		el.value = window.location.href;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	const handleCopyLinkClick = () => {
		copyUrl();
		setIsCopied(true);

		setTimeout(() => {
			setIsCopied(false);
		}, 3000);
	};

	const url = useMemo(() => process.env.NEXT_PUBLIC_URL + pathname, [pathname]);

	// const linkedinUrl = useMemo(() => `https://www.linkedin.com/shareArticle?mini=true&url=${url}`, [url]);
	const facebookUrl = useMemo(() => `https://www.facebook.com/sharer/sharer.php?u=${url}`, [url]);
	const twitterUrl = useMemo(() => `https://twitter.com/intent/tweet?url=${url}`, [url]);

	return (
		<ShareStyle className={props.className || ''}>
			<Text
				className={'h2-L font-futura-light'}
				text={'share'}
			/>

			<div className='links-wrap'>
				<CustomLink
					url={twitterUrl}
					target={'_blank'}
					ariaLabel={'twitter'}
					className={`share-link`}
					rel={'noopener noreferrer'}
					content={
						<Icon
							name={`twitter`}
							className={`share-icon`}
						/>
					}
				/>

				<CustomLink
					url={facebookUrl}
					target={'_blank'}
					ariaLabel={'facebook'}
					className={`share-link`}
					rel={'noopener noreferrer'}
					content={
						<Icon
							name={`facebook`}
							className={`share-icon`}
						/>
					}
				/>

				{/* <CustomLink
					target={'_blank'}
					url={linkedinUrl}
					ariaLabel={'linkedin'}
					className={`share-link`}
					rel={'noopener noreferrer'}
					content={
						<Icon
							name={`linkedin`}
							className={`share-icon`}
						/>
					}
				/> */}

				<div
					className={`share-link`}
					onClick={() => handleCopyLinkClick()}>
					<Icon
						name={`link`}
						className={`share-icon cursor-pointer ${isCopied ? 'is-copied' : ''}`}
					/>
				</div>
			</div>
		</ShareStyle>
	);
};

export default ShareLink;
